import React, {useEffect, useState} from 'react'
import styled from 'styled-components'

import {Link} from 'gatsby'

import AcceptButton from '/src/components/library/Button'

import closeImg from '/static/images/cookies/close.svg'

import ModalCookies from '/src/components/library/ModalCookies'

const Cookies = () => {
    const [modalState, setModalState] = useState(false)
    const [cookies, setCookies] = useState('1')

    useEffect(() => {
        console.log(localStorage.getItem('cookie'))
        setCookies(localStorage.getItem('cookie'))
    }, [])

    useEffect(() => {
        if (cookies === true)
            localStorage.setItem("cookie", true);
    }, [cookies])

    return (
        <>
            {(cookies === undefined || cookies === null) &&
                <StyledCookies cookies={cookies}>
                    <Container>
                        <TextWrapper>
                            <Text>This site uses cookies. By clicking ACCEPT or continuing to browse the site you are
                                agreeing to our use of cookies.
                                <A onClick={() => setModalState(true)}> Find out more.</A>
                            </Text>
                        </TextWrapper>
                        <ExitButtons>
                            <ButtonWrapper>
                                <AcceptButton secondary type={'submit'} label={'Accept'}
                                              onClick={() => setCookies(true)}/>
                            </ButtonWrapper>
                            <CloseButton img={closeImg} onClick={() => setCookies(true)}/>
                        </ExitButtons>
                    </Container>
                    <ModalCookies modalState={modalState} setModalState={setModalState} setCookies={setCookies}
                                  cookies={cookies}/>
                </StyledCookies>
            }
        </>
    )
}

export default Cookies

const StyledCookies = styled.div`
  z-index: 6;
    //display: ${({cookies}) => cookies ? 'none' : 'flex'};
  padding: 2.2rem 12rem 3.5rem 12rem;
  background-color: #C4DBE2;
  position: fixed;
  bottom: 0;
  height: 11.1rem;
  width: 100vw;
  //justify-content: center;
  //align-items: center;
  @media ${({theme}) => theme.breakpoints.mobile} {
    //position: relative;
    height: 18.5rem;
    padding: 2rem 2.5rem 1.6rem 2.5rem;
  }
  
  @media ${({ theme }) => theme.breakpoints.small_height} {
    height: 8rem;  
  }
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media ${({theme}) => theme.breakpoints.mobile} {
    flex-direction: column;
  }
`

const ExitButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    width: 26.5rem;
    justify-content: flex-end;
    align-items: flex-end;
  }
`

const ButtonWrapper = styled.div`
  margin-right: 3rem;
  @media ${({theme}) => theme.breakpoints.mobile} {
    width: 100%;
    //margin-right: 1rem;
    margin-right: 0;
    margin-top: 1.8rem;
    margin-bottom: 1.6rem;
  }
`

// const AcceptButton = styled.button`
//   margin-right: 3rem;
//   color: #FFF;
//   font-family: Sequel75;
//   font-size: 1.6rem;
//   padding: 1.8rem 6rem;
//   border: none;
//   text-decoration: none;
//   background: #0C2637;
// `

const CloseButton = styled.button`
  cursor: pointer;
  text-decoration: none;
  background: none;
  border: none;
  background-image: url(${({img}) => img});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 2.4rem;
  height: 2.4rem;
  align-self: flex-start;
  @media ${({theme}) => theme.breakpoints.mobile} {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
`

// const CloseButton = styled.button`
//   cursor: pointer;
//   text-decoration: none;
//   background: none;
//   border: none;
//   position: absolute;
//   background-image: url(${({img}) => img});
//   background-position: center;
//   background-size: contain;
//   background-repeat: no-repeat;
//   right: 1.6rem;
//   top: 2.2rem;
//   width: 2.4rem;
//   height: 2.4rem;
//   @media ${({theme}) => theme.breakpoints.mobile} {
//     right: .8rem;
//     top: 1rem;
//   }
// `

const TextWrapper = styled.div`
  max-width: 63rem;
  //margin-right: 38rem;
  @media ${({theme}) => theme.breakpoints.mobile} {
    max-width: 26.5rem;
    margin-right: 0;
    //margin-top: 2rem;
  }
`

const Text = styled.span`
  font-family: Sequel45;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.6rem;
`

const A = styled.a`
  cursor: pointer;
  color: #3B869D;
  font-family: Sequel45;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.6rem;
`
